import { Component } from '@angular/core';
import { FlowComponent } from '../flow.component';
import { FlowButtonOverrideService } from '../../../services/flow-button-override.service';
import { Button } from "../../../models/flow.model";

@Component({
    selector: 'read-only-flow',
    templateUrl: '../flow.component.html',
    styleUrls: ['../flow.component.scss'],
    providers: [
        FlowButtonOverrideService
    ],
    standalone: false
})
export class ReadOnlyFlowComponent extends FlowComponent {

    get isReadOnly(): boolean {
        return true;
    }

    ngOnInit() {
        this.onFormGenerated.subscribe(() => {
            for (let questionGroup of this.page.questions) {
                questionGroup.forEach(x => {
                    (x.enabled as any) = () => { return false; };
                });
            }
        });

        super.ngOnInit();
    }

    public isButtonDisabled(button: Button): boolean {
        return !button.isNavigation || button.isTransition;
    }
}
